import React from 'react';

import { TableHead, TableCell, TableRow } from '../TableComponents';
import DiagonalTableCell from './DiagonalTableCell';
import { SplitScore } from '../../Base';
import { COLOR } from '../../Theme';

const TableHeaderSection = ({ columns, score, color }) => (
  <TableHead>
    <TableRow cellBorder={true} bgColor={COLOR.gridGrey}>
      <TableCell minWidth={'90px'} colSpan={2}>
        <DiagonalTableCell right={'คะแนน'} left={'การสอบ'} />
      </TableCell>
      {columns.map((col, index) => {
        return (
          <TableCell
            key={index}
            wrap={true}
            bgColor={score.columnIndex === index && color}
            color={score.columnIndex === index && COLOR.white}
            style={{ padding: '0 2px' }}
          >
            <SplitScore
              score={col[0]}
              fullScore={col[1]}
              seperator={'-'}
              variant="other"
              color={'inherit'}
              align="center"
            />
          </TableCell>
        );
      })}

      <TableCell bgColor={COLOR.greyscale.grey3} wrap={true} textAlign={'center'}>
        รวม (คน)
      </TableCell>
    </TableRow>
  </TableHead>
);

export default TableHeaderSection;
